<div>
  @if (busy) {
    <div class="loading-image-container">
      <div class="loading-image small"></div>
      <div class="loading-text">{{busyMessage}}</div>
    </div>
  }
  <div class="tile-wrapper">
    <mat-card>
      <mat-card-title>New Historical Data Import</mat-card-title>
      @if (viewModel && viewModel.ValidationComplete) {
        <mat-card-content >
          <a mat-raised-button class="mat-accent" (click)="downloadErrorFile(viewModel.Id)"><mat-icon>report</mat-icon>Download Error Report</a>
        </mat-card-content>
      }
    </mat-card>
    @if (!provisioningJob) {
      @if (viewModel && !importResult) {
        <mat-card>
          <mat-card-title>Select Mapping Format</mat-card-title>
          <mat-card-subtitle>Choose the module to import against</mat-card-subtitle>
          <mat-card-content>
            <mat-form-field class="form-field-width-padding">
              <mat-select id="importForModule"
                placeholder="Module"
                [(ngModel)]="selectedModuleId"
                [required]="true"
                (selectionChange)="setModule($event)">
                @for (mi of viewModel.Modules; track mi) {
                  <mat-option [value]="mi.Key">{{mi.Value}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <mat-form-field class="form-field-width-padding">
              <mat-select [disabled]="!viewModel.AvailableStates"
                id="importStateSelect"
                placeholder="Import State"
                [(ngModel)]="selectedStateId"
                required="true"
                (selectionChange)="setButton($event)">
                @for (st of viewModel.AvailableStates; track st) {
                  <mat-option [value]="st.Id">{{st.Name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </mat-card-content>
          <mat-card-subtitle>Choose the file format of the import file.</mat-card-subtitle>
          <mat-card-content>
            <mat-form-field class="form-field-width-padding">
              <mat-select [disabled]="!showFileFormatCard()"
                id="fileType"
                placeholder="File Format"
                [(ngModel)]="selectedFormatId"
                (selectionChange)="updateSelectedFormat() && hasMappings && refreshCustomFields()"
                required="true">
                @for (ft of availableFormats; track ft.Id) {
                  <mat-option [value]="ft.Id">{{ft.Name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </mat-card-content>
          <mat-card-subtitle>Upload File</mat-card-subtitle>
          <mat-card-subtitle>Your file name must start with {{tenantName}}_ and be encoded in UTF-8.</mat-card-subtitle>
          <mat-card-content>
            <label for="fileInput"></label>
            <div>
              <h4>{{filename}}</h4>
            </div>
            <div class="file-buttons">
              <button mat-raised-button class="mat-accent margin-right-1em" (click)="fileInput.click()" [disabled]="!selectedFormatId">
                <mat-icon>file_upload</mat-icon> Browse File&nbsp;&nbsp;&nbsp;
              </button>
              @if (selectedFormatId) {
                <button mat-stroked-button class="mat-primary margin-right-1em" (click)="downloadTemplate()">
                  Download Template
                </button>
              }
              @if (showValidateButton()) {
                <button mat-raised-button class="mat-accent margin-right-1em" (click)="validate(includeAllErrors, includeGoodRowsInReport)"
                  [disabled]="(!this.selectedStateId || !canValidate())">
                  <mat-icon>playlist_add_check</mat-icon> Validate File&nbsp;&nbsp;&nbsp;
                </button>
              }
              @if (showValidateButton()) {
                <div class="display-inline-block">
                  <mat-checkbox class="margin-right-1em" [(ngModel)]="includeAllErrors">Include all errors in report (may take a while)</mat-checkbox><br />
                  <mat-checkbox class="margin-right-1em" [(ngModel)]="includeGoodRowsInReport">Include valid rows in report</mat-checkbox>
                </div>
              }
            </div>
            <input hidden type="file" id="fileInput" #fileInput (change)="previewFile($event)" [accept]="selectedFormat?.Extensions" />
            @if (viewModel.FormatError) {
              <div class="padding-top-1em">
                <span class="error is-flex is-aligned-centre">
                  <mat-icon>highlight_off</mat-icon> {{viewModel.FormatError}}
                </span>
              </div>
            }
          </mat-card-content>
        </mat-card>
      }
      @if (!showMappings && noExtraFieldsInFile) {
        <mat-card>
          <mat-card-content>
            <span class="error">{{mappingsError}}</span>
          </mat-card-content>
        </mat-card>
      }
      <mat-card [ngClass]="{'off-screen': !showMappings}" [hidden]="!showMappings">
        <form #mappingForm="ngForm" (ngSubmit)="saveMapping(mappingForm)">
          <mat-card-title>
            Custom Field Mappings
          </mat-card-title>
          <mat-card-content>
            @if (customFieldMappings && customFieldMappings.length>0 && (showTemplateNameField == false || showTemplateNameField == null)) {
              <mat-form-field class="form-field-width-padding">
                <mat-select
                  id="customFieldMapping"
                  name="customFieldMapping"
                  placeholder="Select Custom Fields Mapping"
                  [(ngModel)]="customFieldMappingId"
                  (selectionChange)="hasMappings && refreshCustomFields()"
                  [disabled]="selectedFormatId==null">
                  @for (cft of customFieldMappings; track cft.Id) {
                    <mat-option [value]="cft.Id">{{cft.Name}}</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            @if (!customFieldMappings || customFieldMappings.length==0 || showTemplateNameField == true) {
              <mat-form-field class="form-field-width-padding">
                <input  matInput
                  required
                  id="customFieldName"
                  name="customFieldName"
                  [(ngModel)]="customFieldName"
                  placeholder="Custom Fields Mapping Name" [disabled]="selectedFormatId==null">
              </mat-form-field>
            }
            @if (customFieldMappings && customFieldMappings.length>0 && (showTemplateNameField == false || showTemplateNameField == null)) {
              <button mat-raised-button
                class="mat-accent"
                (click)="toggleMappingButton(true)"
                [disabled]="selectedFormatId==null">
                Add New Mapping
              </button>
            }
            @if (customFieldMappings && customFieldMappings.length>0 && showTemplateNameField == true) {
              <button mat-raised-button class="mat-accent"
                (click)="toggleMappingButton(false)"
                [disabled]="selectedFormatId==null">
                Select Existing Mapping
              </button>
            }
            <mat-accordion>
              <mat-expansion-panel [expanded]="(!expandMappings || mappingForm.dirty)">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    Custom Field Mappings
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="adjustImportContainer">
                  <div class="uploadConfigContainer tween-and-fade-v2">
                    <div class="To_FromLogoContainer float-left clearfix">
                      <div class="To_FromLogoInner">
                        <label>From:</label>
                      </div>
                      <img class="To_FromLogo" src="../../../../../../assets/img/xlsx-csv.svg" />
                    </div>
                    <div class="space-centre"></div>
                    <div class="To_FromLogoContainer float-left clearfix">
                      <div class="To_FromLogoInner">
                        <label>To:</label>
                      </div>
                      <img class="To_FromLogo" src="../../../../../../assets/img/ecoonline-logo.svg" />
                    </div>
                    <div class="addMappingsSection">
                      @for (cf of customFieldPropertyNames; track $index; let i = $index) {
                        <div class="clearfix mapping-field"
                          >
                          <div matBadge="{{customFieldPropertyNames[i].InputColumnsIndex + 1}}" matBadgePosition="before" matBadgeColor="accent" class="inputPosition align-left">
                            <div class="inputPosition_content">
                              <span class="inputPosition_span-container">
                                @if (customHeaders[i]) {
                                  <span class="inputPosition_span-content">
                                    {{customHeaders[i].InputColumnName}}
                                  </span>
                                }
                                @if (!customHeaders[i]) {
                                  <span class="inputPosition_span-content color-red">
                                    {{cf.InputColumnName}} Doesnt Exist In Source
                                  </span>
                                }
                              </span>
                            </div>
                          </div>
                          <div class="mapping-centre">
                            <img src="../../../../../../assets/img/config-arrow.svg" />
                          </div>
                          <div class="inputPosition align-left">
                            <div class="inputPosition_content">
                              <span class="inputPosition_span-container">
                                <span class="inputPosition_span-content">
                                  <mat-select [(ngModel)]="cf.PropertyName"
                                    [name]="'customFieldPropName_'+i"
                                    awCustomFieldValidator
                                    [customFieldPropertyNames]="customFieldPropertyNames"
                                    placeholder="Select CustomField..."
                                    (selectionChange)="setMultiFieldName($event)">
                                    <mat-option [value]="">- Select -</mat-option>
                                    @for (ff of selectOptions; track ff.Value) {
                                      <mat-option [value]="ff.Key">
                                        <span>{{ff.Value}}</span>@if (ff.MultiFieldName) {
                                        <span> ({{ff.MultiFieldName}})</span>
                                      }
                                    </mat-option>
                                  }
                                </mat-select>
                              </span>
                            </span>
                            @if (mappingForm?.controls['customFieldPropName_' + i]?.errors?.duplicate) {
                              <mat-error >
                                Custom Field mapping must be unique
                              </mat-error>
                            }
                          </div>
                        </div>
                        <div class="trashContainer display-none">
                          <span class="btn btn-icon btn-icon-trash trashPosition" ng-click="DeleteRow($index)"></span>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        </mat-card-content>
        <mat-card-actions>
          <button mat-raised-button class="mat-accent" [disabled]="!mappingForm.dirty" >
            <mat-icon>save</mat-icon>Save Mappings
          </button>
        </mat-card-actions>
      </form>
    </mat-card>
    @if (viewModel && viewModel.Top5Rows && viewModel.Top5Rows.length > 0) {
      <mat-card class="previewPosition">
        <mat-card-title>Preview</mat-card-title>
        <mat-card-content>
          <div class="preview">
            <table>
              <tbody>
                @for (r of viewModel.Top5Rows; track r) {
                  <tr>
                    @for (c of r; track c) {
                      <td>
                        {{c}}
                      </td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </mat-card-content>
      </mat-card>
    }
    @if (viewModel && viewModel.ValidationComplete) {
      <mat-card class="previewPosition">
        <mat-card-title>Validation Results</mat-card-title>
        <mat-card-content>
          <form #doImportForm="ngForm" (ngSubmit)="import()">
            <div>
              @for (setting of viewModel.AdditionalSettings; track setting) {
                <div>
                  <br />
                  <span [hidden]="listLoaded(setting.Values)"><em>Loading List Items...</em></span>
                  <span [hidden]="!listLoaded(setting.Values)">
                    <mat-select matInput placeholder="{{setting.PropertyName}}"
                      [required]="setting.Mandatory"
                      [(ngModel)]="additionalValues[setting.PropertyName]"
                      [name]="'additional_' + setting.PropertyName"
                      id="additional_{{setting.PropertyName}}">
                      @for (val of getListItems(setting.Values); track val) {
                        <mat-option [value]="val.Value">
                          {{val.Text}}
                        </mat-option>
                      }
                    </mat-select>
                  </span>
                  <hr />
                </div>
              }
            </div>
            @if ((this.viewModel.ValidationComplete && this.viewModel.LevelCounts && this.viewModel.LevelCounts.length > 0)) {
              <button mat-raised-button [ngClass]="{'mat-warn': hasErrors(), 'mat-accent': !hasErrors()}" class="tableBtn"
                [disabled]="disableImportButton()">
                <mat-icon>play_circle_outline</mat-icon> Import Data @if (hasErrors()) {
                <span><em>(Rows and nodes with errors will be excluded)</em></span>
                }&nbsp;&nbsp;&nbsp;
              </button>
            }
            @if (!viewModel.Failed && viewModel.importType != 'historicalfileattachments') {
              <div>
                <h3>Validated Nodes Summary</h3>
                @for (l of viewModel.LevelCounts; track l) {
                  <p>
                    <strong>{{l.Key}}</strong>: {{l.Value}}
                  </p>
                }
                <p>
                  <span class="error">
                    @if (viewModel.LevelCounts && viewModel.LevelCounts.length === 0) {
                      <strong>No Valid Nodes were found</strong>
                    }
                  </span>
                </p>
              </div>
            }
            @if (viewModel.ErrorRows && viewModel.ErrorRows.length > 0) {
              <div>
                <hr />
                <h3>Row Errors</h3>
                <div class="scrollable-container">
                  <table class="error-table">
                    <thead>
                      <th>Row</th>
                      <th>Errors</th>
                      @for (header of expectedHeaders; track header) {
                        <th>{{header}}</th>
                      }
                      @for (customHeader of customFieldPropertyNames; track customHeader) {
                        <th>{{customHeader.InputColumnName}}</th>
                      }
                    </thead>
                    <tbody>
                      @for (r of viewModel.ErrorRows; track r; let i = $index) {
                        @if (i<100) {
                          <tr>
                            <td><strong>{{r.RowNumber}}</strong></td>
                            <td>
                              <div class="position-relative">
                                <button mat-flat-button type="button" (click)="showErrors[i] = !showErrors[i]">Show {{r.Errors.length}} Errors</button>
                                @if (showErrors[i]===true) {
                                  <div class="error-details-container">
                                    @for (e of r.Errors; track e) {
                                      <p>
                                        <span class="error">
                                          <mat-icon>highlight_off</mat-icon> {{e.Message}}
                                        </span>
                                      </p>
                                    }
                                  </div>
                                }
                              </div>
                            </td>
                            @for (f of r.Fields; track f; let i = $index) {
                              <td [class]="getFieldClass(r, i)">{{f}}</td>
                            }
                          </tr>
                        }
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
            @if (viewModel.WarningRows && viewModel.WarningRows.length > 0) {
              <div>
                <hr />
                <h3>Row Warnings</h3>
                <div class="scrollable-container">
                  <table class="error-table">
                    <tbody>
                      @for (r of viewModel.WarningRows; track r) {
                        <tr>
                          @for (f of r.Fields; track f; let i = $index) {
                            <td>{{f}}</td>
                          }
                        </tr>
                        <tr>
                          <td [attr.colspan]="r.Fields.length">
                            <p>
                              Row Number: <strong>{{r.RowNumber}}</strong>
                            </p>
                            @for (e of r.Warnings; track e) {
                              <p>
                                <span class="warning">
                                  <mat-icon>info</mat-icon> {{e.Message}}
                                </span>
                              </p>
                            }
                          </td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
            @if (viewModel.NodeErrors && viewModel.NodeErrors.length > 0) {
              <div>
                <hr />
                <h3>Node Errors</h3>
                @for (n of viewModel.NodeErrors; track n) {
                  <div class="node-error">
                    <p>
                      Description: <strong>{{n.NodeDescription}}</strong>
                    </p>
                    <p>
                      <span class="error"><mat-icon>highlight_off</mat-icon> {{n.Error}}</span>
                    </p>
                  </div>
                }
              </div>
            }
            @if (viewModel.ValidationError) {
              <div>
                <div class="node-error">
                  <p>
                    <strong>{{viewModel.ValidationError}}</strong>
                  </p>
                  <p>
                    <span class="error"><mat-icon>highlight_off</mat-icon> {{viewModel.ValidationErrorDetail}}</span>
                  </p>
                </div>
              </div>
            }
            @if (!hasErrors() && viewModel.importType !== 'historicalfileattachments') {
              <div class="all-good">
                <mat-icon>check_circle</mat-icon> No Errors Found
              </div>
            }
          </form>
        </mat-card-content>
      </mat-card>
    }
  }
  @if (provisioningJob) {
    <mat-card>
      <mat-card>
        <mat-card-title>Processing Import</mat-card-title>
        <mat-card-subtitle>You can close this window and the processing will continue in the background.</mat-card-subtitle>
      </mat-card>
      <mat-card>
        <mat-card-title>Progress</mat-card-title>
        <mat-card-content>
          @if (provisioningJob) {
            <job-liveview [jobId]="provisioningJob" (finished)="jobComplete($event)"></job-liveview>
          }
        </mat-card-content>
      </mat-card>
    </mat-card>
  }
  @if (importResult && false) {
    <div>
      <mat-card>
        <mat-card-title>Import Results</mat-card-title>
        <mat-card-content>
          @if (importResult.Success) {
            <div class="all-good">
              <mat-icon>check_circle</mat-icon> No Errors Found, Import Successful
            </div>
          }
          @if (!importResult.Success) {
            <div>
              @for (e of importResult.Errors; track e) {
                <p><span class="error"><mat-icon>highlight_off</mat-icon> {{e}}</span></p>
              }
            </div>
          }
        </mat-card-content>
      </mat-card>
    </div>
  }
</div>
</div>
